export const LEAD_DROP_FORM_1_CONSTANTS = {
  DEFAULT_ROW: {
    title: "",
    sub_text: "",
    checkbox_description: "",
    terms_conditions_link: "",
    privacy_policy_link: "",
    button_text: "",
    button_color: "#BE2330",
    button_icon: "",
    button_text_color: "#FFFFFF",
    button_background_color: "#BE2330",
    success_icon: "",
    success_title: "",
    success_description: "",
    success_description_text_color: "#000000",
    success_description_color: "#000000",
    success_button_icon: "",
    success_button_text: "",
    success_button_text_color: "#FFFFFF",
    success_button_background_color: "#BE2330",
  },

  LEAD_DROP_FORM_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "sub_text",
      label: "Sub Text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Sub Text",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "checkbox_description",
      label: "Checkbox Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder:
        "e.g. I agree to the {{1:Terms & Conditions}} and {{2:Privacy Policy}}",
      required: false,
      defaultValue: "",
      rows: 2,
      description:
        "Consent text shown next to the checkbox. Use {{1:Your text}} to link to the Terms & Conditions Link and {{2:Your text}} for the Privacy Policy Link — the number picks the link, and the text after the colon is what the user sees. Plain text without tokens also works.",
    },
    {
      fieldName: "terms_conditions_link",
      label: "Terms & Conditions Link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://example.com/terms-and-conditions",
      required: false,
      defaultValue: "",
      description:
        "Destination URL for link slot 1. Referenced in Checkbox Description as {{1:Your link text}}.",
    },
    {
      fieldName: "privacy_policy_link",
      label: "Privacy Policy Link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://example.com/privacy-policy",
      required: false,
      defaultValue: "",
      description:
        "Destination URL for link slot 2. Referenced in Checkbox Description as {{2:Your link text}}.",
    },
    {
      fieldName: "button_text",
      label: "Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
      required: false,
      defaultValue: "Submit",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "success_icon",
      label: "Success Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_icon_alt",
      label: "Success Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for success icon",
      required: false,
      defaultValue: "Success",
    },
    {
      fieldName: "success_title",
      label: "Success Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_description",
      label: "Success Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Success Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "success_description_text_color",
      label: "Success Description Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Text Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "success_description_color",
      label: "Success Description Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "success_button_icon",
      label: "Success Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_button_icon_alt",
      label: "Success Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for success button icon",
      required: false,
      defaultValue: "Continue",
    },
    {
      fieldName: "success_button_text",
      label: "Success Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Button Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_button_text_color",
      label: "Success Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "success_button_background_color",
      label: "Success Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
  ],

  METADATA_FIELDS: [],
};

